<template>
  <div id="text-note-wrap">
    <span class="title-and-exit">
      <input 
        type="text" 
        class="title-input"
        :value="title"
        @keyup="updateTitle"/>
      <button class="delete-note" @click="deleteNote">X</button>
    </span>
    <textarea 
      class="text-input" 
      :value="content" 
      @keyup="updateContent"></textarea>
      <!-- v-model="content" -->
  </div>
</template>

<script>
import Note from './Note.vue';

export default {
  name: "TextNote",
  extends: Note,
  created() {
    this.type = 'text';
  }
}
</script>
<style lang="css">
  #text-note-wrap {
    width: 80%;
    margin: 0 0 1em;
    display: flex;
    flex-direction: column;
    justify-content: left;
  }

  #text-note-wrap .title-and-exit {
    display: flex;
    justify-content: space-between
  }

  #text-note-wrap .delete-note {
    font-size: 24px;
    color: #999999;
    text-align: center;
  }

  #text-note-wrap .delete-note:focus {
    outline: none;
  }

  #text-note-wrap input {
    width: 100%;
    margin-bottom: 0.5em;
    font-size: 20px;
    border: none;
    border-bottom: 1px solid #2c3e50;
    border-radius: 0;
  }

  #text-note-wrap input:focus {
    border: 1px solid #2c3e50;
    border-radius: 3px;
  }

  #text-note-wrap textarea {
    height: 8em;
    max-height: 20em;
    border-radius: 2px;
    font-size: 16px;
    resize: vertical; 
  }

  #text-note-wrap textarea:focus {
    outline: none;
  }
</style>